(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8347],{

/***/ 57452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ billing; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/TextArea/index.ts + 2 modules
var TextArea = __webpack_require__(94721);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/name.ts
var regexes_name = __webpack_require__(11703);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/recaptcha-v3/dist/ReCaptcha.js
var ReCaptcha = __webpack_require__(7482);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
;// CONCATENATED MODULE: ./src/views/Contact/BillingPage/helper.ts





/**
 * Handle form error.
 * Fires `Form Failed` track event.
 * @param {Object} error
 */
var handleError = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(error) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0,scripts/* track */.j)("Form Failed", {
              type: error === null || error === void 0 ? void 0 : error.status,
              error: error === null || error === void 0 ? void 0 : error.statusText
            });

          case 3:
            _context.next = 8;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", "error");

          case 8:
            return _context.abrupt("return", "error");

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function handleError(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Contact Billing form onSubmit logic.
 * send a backend contact ticket, or track form failure.
 * @param {FieldValues} formData
 */


var submitContactBillingForm = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(formData) {
    var recaptchaClientKey, recaptcha, token, contactBillingPayload, status;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            // Get recaptcha token for posting to `segment-site-backend`.
            // See https://developers.google.com/recaptcha/docs/v3 for more info.
            recaptchaClientKey = "6Ld9bHgmAAAAAPEt_xy7j9cFx2RxcH0ZomV8q871" || 0;
            _context2.next = 4;
            return (0,ReCaptcha/* load */.zD)(recaptchaClientKey);

          case 4:
            recaptcha = _context2.sent;
            _context2.next = 7;
            return recaptcha.execute("form");

          case 7:
            token = _context2.sent;
            // Set up the payload.
            contactBillingPayload = {
              formId: "",
              formType: "billing",
              formFields: {
                name: formData.name,
                email: formData.email,
                workspaceSlug: formData.slug,
                description: formData.help,
                interestedInFunctions: false,
                interestedInPrivacy: false
              },
              recaptchaToken: token
            }; // Post data to `segment-site-backend` contact ticket endpoint.

            _context2.next = 11;
            return fetch("".concat((0,scripts/* getBackendHost */.kI)(window.location.host, window.location.protocol), "/backend/contact/ticket"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(contactBillingPayload)
            }).then(function (res) {
              return res.json();
            }).then(function (body) {
              // Code 400 is returned when there is a recaptcha error or a zendesk creation ticket error.
              if (body.status !== 400) {
                // Returns FormStatus = `success` to display success message to the user.
                return "success";
              } // Returns FormStatus = `error` to display error message to the user.


              return handleError({
                status: body.status,
                statusText: body.message
              });
            })["catch"](handleError);

          case 11:
            status = _context2.sent;
            return _context2.abrupt("return", status);

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleError(_context2.t0));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 15]]);
  }));

  return function submitContactBillingForm(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var helper = (submitContactBillingForm);
// EXTERNAL MODULE: ./src/views/Contact/BillingPage/assets/OgBilling.jpeg
var OgBilling = __webpack_require__(89938);
var OgBilling_default = /*#__PURE__*/__webpack_require__.n(OgBilling);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Contact/BillingPage/Billing.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


























var slugMessages = {
  required: "Please enter your workspace slug.",
  invalid: "Please enter a valid workspace slug."
};
var helpMessages = {
  required: "Please describe your issue.",
  invalid: "Please provide a valid issue: no special characters."
};
var schema = lib/* object */.Ry({
  email: lib/* string */.Z_().min(1, {
    message: FormFields/* companyEmailMessages.required */.BN.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  }).regex(email/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  })
  /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
  ,
  slug: lib/* string */.Z_().min(1, {
    message: slugMessages.required
  }).regex(regexes_form/* default */.Z, {
    message: slugMessages.invalid
  }),
  name: lib/* string */.Z_().min(1, {
    message: FormFields/* fullNameMessages.required */.aZ.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* fullNameMessages.invalid */.aZ.invalid
  }),
  help: lib/* string */.Z_().min(1, {
    message: helpMessages.required
  }).regex(regexes_form/* default */.Z, {
    message: helpMessages.invalid
  })
});
var copy = {
  formHeading: "Contact Support",
  formDescription: "How can we help you?",
  formButton: "Contact Support",
  successResponseHeading: "Thank you",
  successResponseDescription: "We'll get back to you shortly."
};

var Billing = function Billing() {
  var _errors$slug, _errors$slug2, _errors$slug3, _errors$help, _errors$help2;

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var scroll = (0,useScrollToAnchor/* default */.Z)("billing-form");

  var _useState = (0,react.useState)("idle"),
      formStatus = _useState[0],
      setFormStatus = _useState[1];

  var _useState2 = (0,react.useState)(false),
      valid = _useState2[0],
      setValid = _useState2[1];

  var register = methods.register,
      trigger = methods.trigger,
      errors = methods.formState.errors;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Contact | Twilio Segment",
      pageDescription: "Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data.",
      pageOG: (OgBilling_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
        id: "billing-form",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
          variant: "centered",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
              centered: true,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h1",
                variant: "h1",
                children: copy.formHeading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                tag: "h2",
                variant: "pLarge",
                children: copy.formDescription
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledForm, {
              methods: methods,
              gap: "small",
              onSubmit: function onSubmit(formData) {
                scroll();
                helper(formData).then(setFormStatus);
              },
              success: formStatus === "idle" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormMessageWrapper, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, {
                  "data-hook": "billing-form-response-message",
                  heading: copy.successResponseHeading,
                  description: copy.successResponseDescription,
                  status: "success",
                  appearance: "twilioLight"
                })
              }),
              error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
                status: "error"
              }, TrackableForm/* errorMessage */.N)),
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
                label: "Your billing email",
                placeholder: "you@company.com"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
                id: "slug",
                placeholder: "hitchhikers-gtg",
                label: "Your workspace slug",
                type: "text",
                error: Boolean((_errors$slug = errors.slug) === null || _errors$slug === void 0 ? void 0 : _errors$slug.message),
                errorText: (_errors$slug2 = errors.slug) === null || _errors$slug2 === void 0 ? void 0 : _errors$slug2.message,
                expanded: true,
                showValidState: valid && Boolean(!((_errors$slug3 = errors.slug) !== null && _errors$slug3 !== void 0 && _errors$slug3.message)),
                onAutoFill: function onAutoFill(value) {
                  setValid(regexes_name/* default.test */.Z.test(value));
                  trigger("slug");
                }
              }, register("slug", {
                required: slugMessages.required,
                onBlur: function onBlur(e) {
                  setValid(regexes_name/* default.test */.Z.test(e.target.value));
                }
              }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
                label: "Your name"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextArea/* default */.Z, _objectSpread({
                id: "help",
                expanded: true,
                label: "How can we help?",
                placeholder: "I need help with...",
                error: Boolean((_errors$help = errors.help) === null || _errors$help === void 0 ? void 0 : _errors$help.message),
                errorText: (_errors$help2 = errors.help) === null || _errors$help2 === void 0 ? void 0 : _errors$help2.message,
                maxWidth: "855px",
                rows: 4
              }, register("help", {
                required: helpMessages.required
              }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitButton, {
                color: "primary",
                variant: "filled",
                size: "large",
                children: copy.formButton
              })]
            })
          })]
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "euyj8da5"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "euyj8da4"
} : 0)(Section/* Wrapper */.im, "{margin:0 auto;max-width:940px;grid-template-columns:1fr;row-gap:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:64px;}}" + ( true ? "" : 0));

var SubmitButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "euyj8da3"
} : 0)( true ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : 0);

var FormMessageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euyj8da2"
} : 0)( true ? {
  name: "1mtfyje",
  styles: "max-width:410px;margin:0 auto"
} : 0);

var StyledForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TrackableForm/* default */.Z,  true ? {
  target: "euyj8da1"
} : 0)( true ? {
  name: "1coh6b9",
  styles: "min-height:200px"
} : 0);

var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euyj8da0"
} : 0)( true ? {
  name: "2zbb5s",
  styles: "display:flex;justify-content:center;min-height:180px;align-items:center"
} : 0);

/* harmony default export */ var BillingPage_Billing = (Billing);
;// CONCATENATED MODULE: ./src/pages/contact/billing.tsx



var billing_Billing = function Billing() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BillingPage_Billing, {});
};

/* harmony default export */ var billing = (billing_Billing);

/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 26898:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/billing",
      function () {
        return __webpack_require__(57452);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89938:
/***/ (function(module) {

module.exports = "/_next/static/images/OgBilling-c0ae553312ed6b8b9ad809413ed0d934.jpeg";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,3607,9137,3254,1382,4136,8392,2073,7096,7303,4488,948,8187,8726,9774,2888,179], function() { return __webpack_exec__(26898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);